import { useDataProvider } from "ra-core";
import { useEffect, useState } from "react";

import FormField from "../models/FormField";
import MemberForm from "../models/Form";
const useOneMemberCI = (id) => {
  const [member, setMember] = useState(null);
  const [form, setForm] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();
  const dataProvider = useDataProvider();
  useEffect(() => {
    async function getOneMember(id) {
      try {
        const form = await dataProvider.getList("onboard/subscribe/form", {
          code: "FORM:MEMBER:ONBOARD:2.0",
        });

        const fields = form.data.map((d) => new FormField(d));
        const mForm = new MemberForm(fields);

        const member = await dataProvider.getOne("members", {
          id: id,
          data: {
            addon: {
              ...mForm.getProjection(),
              id: 1,
              i18n: 1,
              tier: 1,
              lifetime_value: 1,
              image_url: 1,
              educations: 1,
              works: 1,
              socials: 1,
              code: 1,
              __v: 1,
              branch_id: 1,
              instagram_id: 1,
            },
          },
        });
        setForm(mForm);
        setMember(member.data);
        return setLoading(false);
      } catch (error) {
        setLoading(false);
        return setError(error);
      }
    }

    setLoading(true);
    getOneMember(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return { member, form, loading, error };
};

export default useOneMemberCI;
